export default "__VITE_ASSET__Bjb14D6L__"